import { ContentBlocks } from "src/ui/ContentBlocks";
import { SeoHead } from "src/ui/SeoHead";

export default function FeaturedClientsPage({ prefix, title, canonical, data }) {
  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <ContentBlocks data={data} prefix={prefix} />
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {
      prefix: "featured_clients",
      title: "Featured Clients",
      canonical: "/about-us/featured-clients/",
      data: [
        {
          component: "Hero",
          props: {
            tagline: "About Us",
            title: "Featured Clients",
            image: "/assets/featured_clients_hero.webp",
            buttons: [
              {
                label: "Our Services",
                url: "/clients/our-services/",
              },
            ],
          },
        },
        {
          component: "Content",
          props: {
            className: "py-4",
            description:
              "<p>We work with a number of leading science and technology companies who provide temporary, contract and permanent employment opportunities through us. If you are interested in working with any of these companies please contact us to see how we can help you.</p>",
          },
        },
        {
          component: "FeaturedClients",
          props: {
            title: "Featured HRS Clients",
          },
        },
        {
          component: "BlockQuoteSideImage",
          props: {
            className: "py-5 py-md-6",
            quote:
              "<p>At HRS, we believe that working in close partnership with our clients isn’t just about filling roles—it’s about building lasting relationships that drive real impact.</p><p>Our <b>Featured Clients</b> represent companies that share our commitment to talent, innovation, and excellence. Together, we’re shaping the future of life sciences by attracting, developing, and retaining the best people in the industry.</p>",
            cite: "Ricky Martin BSc (Hons) FIRP CertRP MRSC",
            role: "Managing Director, Hyper Recruitment Solutions",
            image: "/assets/featured_clients_blockquote_image.webp",
          },
        },
        {
          component: "ContentSideImages",
          props: {
            className: "pt-6 pb-7 py-md-7",
            title: "Start applying for your ideal job today!",
            reverse: true,
            image_1: "/assets/featured_clients_cta_1.webp",
            image_2: "/assets/featured_clients_cta_2.webp",
            image_2_hexagon: false,
            buttons: [
              {
                label: "Upload your CV",
                url: "/upload-cv/",
              },
            ],
          },
        },
      ],
    },
  };
}
